import PlusIcon from '@heroicons/react/24/outline/PlusIcon';
import { ReactNode } from 'react';

import { Button } from '@/components/core/Button';
import { useTranslation } from '@/hooks/useTranslation';

interface DamLibraryHeaderProps {
    /** Opens the upload wizard. The button stays disabled while no handler is wired. */
    onAddFiles?: () => void;
    /** Row below the divider (search, filter and tag controls). */
    children?: ReactNode;
}

function DamLibraryHeader({ onAddFiles, children }: DamLibraryHeaderProps) {
    const { t } = useTranslation();

    return (
        <header className="tw-flex tw-flex-col tw-gap-6 tw-p-4 md:tw-p-8 xl:tw-px-10">
            <div className="tw-flex tw-flex-col tw-gap-4 md:tw-flex-row md:tw-items-center md:tw-gap-2">
                <h1 className="tw-m-0 tw-min-w-0 tw-flex-1 tw-text-t-lg tw-font-bold tw-text-h-primary lg:tw-text-t-xl">
                    {t('DAM.TITLE')}
                </h1>
                <Button
                    hasIcon
                    icon={PlusIcon}
                    disabled={!onAddFiles}
                    onClick={onAddFiles}
                    className="tw-w-full md:tw-w-auto"
                >
                    {t('DAM.ADD_NEW_FILES')}
                </Button>
            </div>
            <hr className="tw-m-0 tw-border-x-0 tw-border-b-0 tw-border-t tw-border-solid tw-border-divider" />
            {children}
        </header>
    );
}

export { DamLibraryHeader };
export type { DamLibraryHeaderProps };
